import React from 'react';
import { humanizeNumber } from '../../helpers/formatters';
import styles from './bar-chart.module.scss';
export default function Legend({ min, max, unit }) {
  return (
    <div className={styles.barChartLegend}>
      <div>{humanizeNumber(min, unit)}</div>
      <div>{humanizeNumber(max, unit)}</div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/bar-chart/legend.js